export default __webpack_public_path__ + "static/media/vg.c671fee4.svg";